enum MessageSubject {
    ORGANIZATION_SIGNUP = 'Signup for Cyber Range Services'
}

export default MessageSubject;